import { createContext, useContext } from 'react';
import { TourState } from './useTourState';

const NOOP_STATE: TourState = {
  isTourPending: false,
  isTourCompleted: false,
  isTourRunning: false,
  markTourPending: () => {},
  startTour: () => {},
  completeTour: () => {},
  skipTour: () => {},
  hasSeenTooltip: () => true,
  markTooltipSeen: () => {},
  isChecklistDismissed: true,
  dismissChecklist: () => {},
};

export const TourContext = createContext<TourState>(NOOP_STATE);

export function useTourContext(): TourState {
  return useContext(TourContext);
}
